<template>
  <EditableTableItem
    @opened-field="focusOnInput"
    @click.stop
    @editing="change"
    :alwaysOpen="alwaysOpen"
    ref="editable"
  >
    <template #input>
      <div class="input-container d-flex">
        <input class="flex-grow-1 pl-2 barcode-input"
          ref="input"
          type="text"
          v-model="newValue"

          @keydown="saveNewValue"
        />
        <div class="button-group" @click.stop>
          <button v-if="!alwaysOpen" class="btn btn-blue" @click="save">Opslaan</button>
          <button class="btn btn-grey" @click="generate">Genereer</button>
        </div>
      </div>
    </template>
    {{ value }}
  </EditableTableItem>
</template>

<script>

import EditableTableItem from "./EditableTableItem.vue"

// import EanGenerator from "ean-generator"

export default {
  components: {
    EditableTableItem,
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    skipEnter: Boolean,
    alwaysOpen: Boolean,
    saveOnChange: Boolean,
  },
  data() {
    return {
      newValue: this.value || "",
    }
  },
  methods: {
    change() {
      if (this.newValue === "---") {
        this.newValue = ""
      }
    },
    generate() {
      if (!this.alwaysOpen) this.$parent.columnSizes.ean13 = 290
      this.$handlePromise(async () => {
        this.newValue = (await this.axios.get("/api/ean13")).data.ean13
        if (this.saveOnChange) this.saveNewValue()
      })
    },

    saveNewValue({key} = {}) {
      if (!this.skipEnter) {
        if (key !== "Enter" && !this.saveOnChange) return;
      }

      this.$emit("save", this.newValue)
      if (!this.alwaysOpen) {
        this.$refs.editable.editing = false
      }
    },
    save() {
      this.$emit("save", this.newValue)
      this.$refs.editable.editing = false
    },
    focusOnInput() {
      this.newValue = this.value
      this.$nextTick(() => this.$refs.input.focus())
    },
  },
  watch: {
    value(val) {
      this.newValue = val
    },
    newValue(val) {
      if (this.skipEnter) {
        this.$emit("save", val)
      }
    },
  },
  mounted(){
    this.$watch(() => {
      if (this.$refs.editable.editing && this.$parent.columnSizes)
        this.$parent.columnSizes.ean13 = 290
      if (!this.$refs.editable.editing && this.$parent.columnSizes)
        this.$parent.columnSizes.ean13 = 140
    })
  }
}

</script>

<style scoped>

.barcode-input, .btn {
  border-radius: 1px;
}

.btn {
  color: var(--white);
  font-size: 0.8125em;
  padding: 4px !important;
}
.btn-blue {
  background-color: var(--blue);
  border-radius: 0px;
  margin-left: -1px;
}

.btn-grey {
  background-color: var(--black-40);
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

input {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.input-container {
  border-radius: 1px;
}

input, .input-container {
  width: 130px !important;
}

.button-group {
  display: flex;
  justify-content: space-around;
}
</style>
